
import Vue from "vue";
export default Vue.extend({
    props: {
        label: String,
    },
    methods: {
        openFileInput() {
            const input = this.input;
            if (input) {
                input.click();
            }
        },
        async importExpenses() {
            const files = this.input.files;
            if (files) {
                const file = files[0];
                console.log(file);
                if (file) {
                    this.input.value = "";
                    this.$emit("loaded", file);
                }
            }
        },
    },
    computed: {
        input() {
            const input = this.$refs["file-input"] as HTMLInputElement;
            return input;
        },
    },
});
